
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    DesignSize: {
      DesignWidth: 1920, // 设计宽度
      DesignHeight: 3200, // 设计高度
      SafeWidth: 1920, // 安全区宽度
      SafeHeight: 3200 // 安全区高度
    },
    WindowSize: {
      WindowWidth: window.innerWidth, // 屏幕宽度
      WindowHeight: window.innerHeight, // 屏幕高度
      WindowWidthRem: window.innerWidth, // 屏幕宽度
      WindowHeightRem: window.innerHeight // 屏幕高度
    },
    AutoPositon: {
      width: 0,
      height: 0,
      OffsetX: 0,
      OffsetY: 0,
      FontSize: 0
    }
  },
  mutations: {
    addAcm(state,Acm){
      state.acmList=state.acmList.concat(Acm);
    },
    removeAcm(state){
      state.acmList.shift();
    },
    getGameID(state,id){
      state.gameID=id;
    },
    musicOn(state){
      state.musicPlay=1;
    },
    musicOff(state){
      state.musicPlay=0;
    },
    SetWindowSize(state) {
      state.WindowSize.WindowWidth = window.innerWidth;
      state.WindowSize.WindowHeight = window.innerHeight;
      const WindowP =
        state.WindowSize.WindowWidth / state.WindowSize.WindowHeight;
      const SafeP = state.DesignSize.SafeWidth / state.DesignSize.SafeHeight;
      let p = 0;
      if (WindowP < SafeP) {
        p = state.WindowSize.WindowWidth / state.DesignSize.SafeWidth;
        state.AutoPositon.width = state.DesignSize.DesignWidth * p + "px";
        state.AutoPositon.height = state.DesignSize.DesignHeight * p + "px";
        state.AutoPositon.OffsetX =
          ((state.DesignSize.SafeWidth - state.DesignSize.DesignWidth) / 2) *
          p +
          "px";
        state.AutoPositon.OffsetY =
          (state.WindowSize.WindowHeight - state.DesignSize.DesignHeight * p) /
          2 +
          "px";
        state.AutoPositon.FontSize = 100 * p + "px";
      } else {
        p = state.WindowSize.WindowHeight / state.DesignSize.SafeHeight;
        state.AutoPositon.width = state.DesignSize.DesignWidth * p + "px";
        state.AutoPositon.height = state.DesignSize.DesignHeight * p + "px";
        state.AutoPositon.OffsetX =
          (state.WindowSize.WindowWidth - state.DesignSize.DesignWidth * p) /
          2 +
          "px";
        state.AutoPositon.OffsetY =
          ((state.DesignSize.SafeHeight - state.DesignSize.DesignHeight) / 2) *
          p +
          "px";
        state.AutoPositon.FontSize = 100 * p + "px";
      }
      state.WindowSize.WindowWidthRem =
        state.WindowSize.WindowWidth / (100 * p);
      state.WindowSize.WindowHeightRem =
        state.WindowSize.WindowHeight / (100 * p);
      document.documentElement.style.fontSize = state.AutoPositon.FontSize;
    },
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js